import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected: boolean;
  icon?: ReactNode;
  children: ReactNode;
}

export function ChoiceButton({
  selected,
  icon,
  children,
  className = '',
  disabled,
  ...rest
}: Props) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      className={`min-h-[44px] px-3 py-2.5 rounded-xl border-2 font-semibold text-xs text-center transition-all duration-150 flex items-center justify-center gap-1.5 ${
        selected
          ? 'border-[var(--brand-primary,#22D3EE)] bg-[rgba(34,211,238,0.07)] text-[var(--brand-navy,#0A1128)] shadow-[0_0_0_3px_rgba(34,211,238,0.10)]'
          : 'border-[var(--line,rgba(15,30,51,0.08))] bg-white text-[var(--ink,#0F1E33)]'
      } ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      {...rest}
    >
      {icon && (
        <span
          className={
            selected
              ? 'text-[var(--brand-primary,#22D3EE)]'
              : 'text-[var(--t2,rgba(15,30,51,0.66))] opacity-70'
          }
          style={{ display: 'inline-flex', width: '14px', height: '14px' }}
        >
          {icon}
        </span>
      )}
      <span>{children}</span>
    </button>
  );
}
